<template>
    <div class="glowing-image">
      <!-- Blurred background image -->
      <img class="glow" :src="src" :style="glowStyle" alt="" />
      <!-- Foreground (main) image -->
      <img class="main" :src="src" alt="" />
    </div>
  </template>
  
  <script>
  export default {
    name: "ImageGlow",
    props: {
      src: { type: String, required: true },
      // Blur radius in pixels for the background glow.
      blur: { type: Number, default: 8 },
      // Opacity for the blurred image.
      opacity: { type: Number, default: 1 }
    },
    computed: {
      glowStyle() {
        return {
          filter: `blur(${this.blur}px)`,
          opacity: this.opacity
        };
      }
    }
  };
  </script>
  
  <style scoped>
  .glowing-image {
    position: relative;
    display: inline-block;
  }
  .glowing-image img {
    display: block;
    max-width: 100%;
  }
  .glowing-image .glow {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .glowing-image .main {
    position: relative;
    z-index: 1;
  }
  </style>
  